
/* ==========================================
   A2Z CORE VALUES CAROUSEL
   ========================================== */

(() => {
  const initialized = new WeakSet();

  function init(section) {
    if (initialized.has(section)) return;

    const track = section.querySelector(
      '[data-values-track]'
    );

    const slides = Array.from(
      section.querySelectorAll('[data-value-slide]')
    );

    const prev = section.querySelector(
      '[data-values-prev]'
    );

    const next = section.querySelector(
      '[data-values-next]'
    );

    const counter = section.querySelector(
      '[data-values-counter]'
    );

    if (!track || slides.length === 0) return;

    initialized.add(section);

    let index = 0;

    function showSlide(newIndex) {
      index = (
        newIndex + slides.length
      ) % slides.length;

      track.style.transform =
        `translateX(-${index * 100}%)`;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;

        slide.setAttribute(
          'aria-hidden',
          String(!active)
        );

        if ('inert' in slide) {
          slide.inert = !active;
        }
      });

      if (counter) {
        counter.textContent =
          `${index + 1} / ${slides.length}`;
      }
    }

    prev?.addEventListener('click', () => {
      showSlide(index - 1);
    });

    next?.addEventListener('click', () => {
      showSlide(index + 1);
    });

    showSlide(0);
  }

  function initAll(root = document) {
    if (root.matches?.('[data-a2z-values]')) {
      init(root);
    }

    root.querySelectorAll(
      '[data-a2z-values]'
    ).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    event => initAll(event.target)
  );
})();
